const types = {
  LOADING: 'app/app/LOADING',
  LOADED: 'app/app/LOADED',
  LOADER_DISPLAY: 'app/app/LOADER_DISPLAY',
  RESET_LOADING: 'app/app/RESET_LOADING',
};

export default types;
